export class PublishedJobParams {
    confirmed: boolean
    hours: number
    minutes: number
    seconds: number
    createDate: number
    timeKeeping: number
    timeStopBidding: number
    secondTimeKeeping: number
    biddingActiveDate: number
}



// WEBPACK FOOTER //
// ./src/types/PublishedJobParams.ts